import { Outlet } from 'react-router-dom';
import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

// ============================================================
// ALDRIN'S - CLIENT INTERFACE LAYOUT
// Design: Clair, Moderne, Minimaliste
// Couleurs: Vert naturel, Bois clair, Gris léger, Fond blanc
// ============================================================

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Settings Context for sharing restaurant settings across pages
const SettingsContext = createContext();

export const useSettings = () => {
    const context = useContext(SettingsContext);
    if (!context) {
        return {
            settings: {
                restaurant_name: "ALDRIN'S",
                tagline: "Restaurant & Bar",
                welcome_message: "Cuisine authentique et ambiance conviviale à Libreville.",
                show_prices: true,
                hero_image_url: null,
                logo_url: null,
                phone: "+241 77 71 27 78",
                whatsapp: "+241 77 00 00 00",
                email: "aschrislay@gmail.com",
                address: "Damas, Libreville - 4ème carrefour, après Prix Import d'Awendjé, avant l'école Sacré-Cœur",
                hours: [
                    { days: "Lundi - Dimanche", time: "08h00 - 19h00" }
                ]
            },
            loading: false
        };
    }
    return context;
};

// Main Layout Component - Clean White Theme
const ClientLayout = () => {
    const [settings, setSettings] = useState({
        restaurant_name: "ALDRIN'S",
        tagline: "Restaurant & Bar",
        welcome_message: "Cuisine authentique et ambiance conviviale à Libreville.",
        show_prices: true,
        show_descriptions: true,
        reservations_enabled: true,
        hero_image_url: null,
        logo_url: null,
        phone: "+241 77 71 27 78",
        whatsapp: "+241 77 71 27 78",
        email: "aschrislay@gmail.com",
        address: "Damas, Libreville - 4ème carrefour, après Prix Import d'Awendjé, avant l'école Sacré-Cœur",
        hours_weekday: "Lun-Sam: 08h-19h",
        hours_sunday: "Dim: Fermé",
        hours: [
            { days: "Lundi - Samedi", time: "08h00 - 19h00" },
            { days: "Dimanche", time: "Fermé" }
        ],
        social: {
            instagram: "",
            facebook: ""
        }
    });
    const [loading, setLoading] = useState(true);
    
    // Fetch restaurant settings on mount
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/client/settings`);
                if (response.data) {
                    setSettings(prev => ({ ...prev, ...response.data }));
                }
            } catch (error) {
                console.log('Using default settings');
            } finally {
                setLoading(false);
            }
        };
        
        fetchSettings();
    }, []);
    
    // Context value
    const settingsContextValue = {
        settings,
        loading
    };
    
    return (
        <SettingsContext.Provider value={settingsContextValue}>
            <div className="min-h-screen bg-white">
                {/* Page Content - Rendu immédiat sans animation bloquante */}
                <Outlet />
            </div>
        </SettingsContext.Provider>
    );
};

export default ClientLayout;
